import React from 'react';
import SearchBox from '../../../../components/outline/SearchBox';
import BaseForm from '../../../../components/form/BaseForm';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import Input from '../../../../components/input/Input';
import Select from '../../../../components/input/Select';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import {
  SEARCH_WORD_LIST_SEARCH_DATA_MODEL,
  SEARCH_WORD_LIST_SEARCH_OPTION_MODEL,
} from '../../../../store/modules/searchWord/models';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { SEARCH_WORD_SEARCH_DATE_TYPE_SELECT_LIST } from '../../../../constants/service/app/searchWordConstants';
import './SearchWordListSearchBox.scss';

const SearchWordListSearchBox = (props) => {
  const { setData, searchData, getList } = props;
  const { searchWordId, word, searchDate } = searchData;

  return (
    <SearchBox
      className="search-word-list-search-box"
      onSearch={() =>
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        })
      }
      onClear={() => {
        getList({
          searchOption: SEARCH_WORD_LIST_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: SEARCH_WORD_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*검색 키워드 ID */}
      <BaseForm
        label="ID"
        content={
          <Input
            value={searchWordId}
            onChange={(value) =>
              setData({
                path: ['searchWordId'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={30}
            size="large"
          />
        }
      />

      {/*검색 키워드 */}
      <BaseForm
        label="키워드"
        content={
          <Input
            value={word}
            onChange={(value) =>
              setData({
                path: ['word'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={30}
            size="large"
          />
        }
      />

      {/*검색 키워드 생성일 */}
      <BaseForm
        label={
          <Select
            list={SEARCH_WORD_SEARCH_DATE_TYPE_SELECT_LIST}
            onChange={(value) =>
              setData({
                path: ['searchDate', 'type'],
                value,
              })
            }
            value={searchDate.type}
            isTable={true}
          />
        }
        content={
          <DateRangePicker
            value={searchDate.value}
            format={DATE_FORMAT.YMD_DASH_FORMAT}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={(value) =>
              setData({
                path: ['searchDate', 'value'],
                value,
              })
            }
          />
        }
      />
    </SearchBox>
  );
};

export default SearchWordListSearchBox;
